import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import Products from "../@Components/Products/Products";

const ProductsPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <Products />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default ProductsPage;
